import { render } from "./JobNotificationGeneric.vue?vue&type=template&id=6293ec04"
import script from "./JobNotificationGeneric.vue?vue&type=script&lang=js"
export * from "./JobNotificationGeneric.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/bambl/V3/v2026.6.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__